import { NgModule } from '@angular/core';
import { DiscountModelDictPipe } from './discount-model-dict.pipe';
import { AgreementStatusDictPipe } from './agreement-status-dict.pipe';
import { VehicleTypeDictPipe } from './vehicle-type-dict.pipe';
import { CardStatusPipe } from './card-status.pipe';
import { AgreementTypeDictPipe } from './agreement-type-dict.pipe';
import { MomentModule } from 'angular2-moment';
import { McCalendarPipe } from './calendar.pipe';
import { CardTypeDictPipe } from './card-type-dict.pipe';


const pipes = [ DiscountModelDictPipe,
                McCalendarPipe,
                AgreementStatusDictPipe,
                CardStatusPipe,
                CardTypeDictPipe,
                AgreementTypeDictPipe,
                VehicleTypeDictPipe ];

@NgModule({
  imports:      [ MomentModule ],
  declarations: pipes,
  exports:      pipes,
  providers:    []
})
export class PipesModule {
}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/pipes/pipes.module.ts